import React from 'react'
// view components
import AiUsage from 'components/PageComponents/Settings/AiUsage'

const AiUsagePage: React.FC = () => <AiUsage />

export default AiUsagePage
